// @flow
import React from "react"
import { Text } from "componentsStyled/Typography/Texts"
import { AffiliateNameWrap } from "./styled"
import PlaceIcon from "./PlaceIcon"

type Props = {|
  name: string,
|}

const AffiliateName = ({ name }: Props) => (
  <AffiliateNameWrap>
    <PlaceIcon />
    {/* TODO - maybe do this in admin instead? or perhaps we keep it just for mobile */}
    <Text>{name.replace("San Francisco", "SF")}</Text>
  </AffiliateNameWrap>
)

export default AffiliateName



// WEBPACK FOOTER //
// ./src/components/AffiliateName/index.js